var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.footer},[_c('div',{class:_vm.$style.footerInner},[_vm._v(" Hallmark Business Connections "),_c('span'),_c('br'),_c('p',{staticClass:"mb-0"},[_vm._v(" Copyright © "+_vm._s(this.currentYear)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }